import React, { useContext } from "react"
import { PCViewContext } from "../Common/PCViewContext"
import Breadcrumb from "react-bootstrap/Breadcrumb"
import * as styles from "./Styles/Breadcrumb.module.scss"
import "./Styles/bootstrap_breadcrumb"
import "../../styles/layouts"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)

const BC = (props) => {
  const isPC = useContext(PCViewContext)

  return (
    <React.Fragment>
      <hr className="common-hr" />
      <Breadcrumb className={cn("breadcrumb", isPC ? "pc" : "sp")}>
        <Breadcrumb.Item className={styles.item} href="/">
          ロコガイド
        </Breadcrumb.Item>
        {props.prefecture && (
          <Breadcrumb.Item className={styles.item} href={props.prefecture.path}>
            {props.prefecture.name}
          </Breadcrumb.Item>
        )}
        {props.city && props.prefecture.name != props.city.name && (
          <Breadcrumb.Item className={styles.item} href={props.city.path}>
            {props.city.name}
          </Breadcrumb.Item>
        )}
        {props.category && (
          <Breadcrumb.Item className={styles.item} href={props.category.path}>
            {props.category.name}
          </Breadcrumb.Item>
        )}
        {props.place && (
          <Breadcrumb.Item
            href={props.place.path}
            className={cn("item", "detail")}
          >
            {props.place.name}
          </Breadcrumb.Item>
        )}
      </Breadcrumb>
    </React.Fragment>
  )
}

export default BC
